import { useContext } from 'react';
import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { cn } from '~/chords/lib/cn';

import { BreadcrumbsContext } from './BreadcrumbsContext';
import { breadcrumbsLinkVariants } from './variants';

export function BreadcrumbsItem({
  to,
  children,
  ...delegatedProps
}: Omit<Partial<LinkProps>, 'className'>) {
  const { emphasis } = useContext(BreadcrumbsContext);

  if (!to) {
    return (
      <span
        {...delegatedProps}
        aria-current="page"
        className={cn('break-all text-default')}
      >
        {children}
      </span>
    );
  }

  return (
    <Link
      {...delegatedProps}
      to={to}
      className={breadcrumbsLinkVariants({ emphasis })}
    >
      {children}
    </Link>
  );
}

BreadcrumbsItem.displayName = 'BreadcrumbsItem';
